// 广告位无广告时背景图片0
export default [
    "https://file2.speedtest.cn/www/bg-img/bg-w300-h250-1.png",
    "https://file2.speedtest.cn/www/bg-img/bg-w300-h250-2.png",
    "https://file2.speedtest.cn/www/bg-img/bg-w300-h250-3.png",
    "https://file2.speedtest.cn/www/bg-img/bg-w360-w217.png",
]



// WEBPACK FOOTER //
// ./resources/js/config/noAdBgcSrcList.js